/*
 * @Author: your name
 * @Date: 2021-03-10 11:22:29
 * @LastEditTime: 2021-08-09 18:15:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_che:\git\mooklookweb\mooklook_web\src\main.js
 */

import Vue from 'vue';

import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/default.less'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'lib-flexible';

import App from './App';
import router from './router';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.less'
import VideoPlayer from 'vue-video-player'
import Swiper2, { Navigation,Pagination as P, EffectFade, Autoplay } from 'swiper'
Swiper2.use([Navigation, P, EffectFade, Autoplay])


import { Row, Col, Message, Dropdown, DropdownMenu, Tabs, DropdownItem, Drawer, Menu, Submenu, MenuItemGroup, MenuItem, TabPane, Carousel, CarouselItem,Pagination} from 'element-ui';
// import ElementUI from 'element-ui';
// 轮播插件
Vue.use(VueAwesomeSwiper)
// 视频插件
Vue.use(VideoPlayer)
// element组件
// Vue.use(ElementUI)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(Tabs)
Vue.use(DropdownItem)
Vue.use(Drawer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(TabPane)
Vue.use(Carousel)
Vue.use(Pagination)
Vue.use(CarouselItem)



Vue.config.productionTip = false;
// Vue.prototype.lange = "JPN";
Vue.prototype.lange = "Ch";


router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

